import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { UFOExperience, untilAll } from '@atlassian/ufo';
import { allowedExperienceTimings, composeExperienceName } from '../utils';
export var ExperienceStore = /*#__PURE__*/function () {
  function ExperienceStore(config) {
    _classCallCheck(this, ExperienceStore);
    _defineProperty(this, "ufoExperiences", new Map());
    this.config = config;
    this.commonExperienceConfig = {
      platform: {
        component: config.ufoAttributes.component
      }
    };
  }
  _createClass(ExperienceStore, [{
    key: "createNewUFOExperience",
    value: function createNewUFOExperience(experienceName, type, performanceType) {
      return new UFOExperience(experienceName, _objectSpread(_objectSpread({}, this.commonExperienceConfig), {}, {
        type: type,
        performanceType: performanceType,
        timings: allowedExperienceTimings(experienceName)
      }));
    }
  }, {
    key: "getOrCreateUFOExperience",
    value: function getOrCreateUFOExperience(nameConfig) {
      var fullExperienceName = composeExperienceName(nameConfig);
      var experience = this.ufoExperiences.get(fullExperienceName);
      if (!experience) {
        var experienceConfig = this.config.ufoAttributes.experienceConfig;
        experience = this.createNewUFOExperience(nameConfig.name, experienceConfig.type, experienceConfig.performanceType);
        this.ufoExperiences.set(fullExperienceName, experience);
      }
      return experience;
    }
  }, {
    key: "getOrCreateUFOExperiences",
    value: function getOrCreateUFOExperiences(nameConfigs) {
      var _this = this;
      return nameConfigs.map(function (nameConfig) {
        return _this.getOrCreateUFOExperience(nameConfig);
      });
    }
  }, {
    key: "getOrCreateUFOExperienceWithDeps",
    value: function getOrCreateUFOExperienceWithDeps(nameConfig, untilAllDeps) {
      var experience = this.getOrCreateUFOExperience(nameConfig);
      if (!experience.until) {
        experience.until = untilAll(this.getOrCreateUFOExperiences(untilAllDeps).map(function (experience) {
          return {
            experience: experience
          };
        }));
      }
      return experience;
    }
  }, {
    key: "get",
    value: function get(experience) {
      return this.ufoExperiences.get(experience);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return Object.values(this.ufoExperiences);
    }
  }]);
  return ExperienceStore;
}();